/* eslint-disable no-unused-expressions */
import React from 'react';
import './ControlListDetail.css';
import * as actionsLists from '../../Redux/Actions/ControlLists.js';
import 'bootstrap/dist/css/bootstrap.css';
import {store} from '../../Redux/Store/Store';
import {connect} from 'react-redux';
import {DetailListTree} from '../DetailListTree/DetailListTree';
import {Waiter} from '.././WaitingSign/Waiting';
import PopUp from "../PopUp/PopUp";
import {generateChecklistDocx} from '.././DocxTemplate/ChecklistDocx';

export const GET_CONTROL_LIST_DATA_REQUESTED = 'GET_CONTROL_LIST_DATA_REQUESTED';
export const GET_CONTROL_LIST_DATA_DONE = 'GET_CONTROL_LIST_DATA_DONE';
export const GET_CONTROL_LIST_DATA_FAILED = 'GET_CONTROL_LIST_DATA_FAILED';

class ControlListDetail extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			openedPopup: true,
			popUp: {title: null, notification: null},
		}
	}

	listId;

	componentDidMount() {
		const {listData} = this.props;
		this.listId = this.props.match.params.listId;
		listData(this.listId);
	}

	goBack = () => {
		this.props.history.goBack();
	};

	handleClosePopUp() {
		this.setState({openedPopup: false});
	}

	render() {
		let loadedListData = store.getState().controlList.controlList;
		let blocksInList = loadedListData.blocksInList;
		document.title = `e-Kontrole | Lista sprawdzająca: ${loadedListData.name}`;
		let error = store.getState().controlList;

		return (
			<div className='mb-5'>
				<button type='button' onClick={() => generateChecklistDocx(loadedListData)} className='doc-button'>
					<img
						className='ico-doc'
						src='/icoDoc.svg'
						alt='Pobierz dokument .docx'
					/>
				</button>
				<button className='btn save-btn' id='plus_img_container' onClick={this.goBack}><i data-v-db6946bc=''
				                                                                                  aria-hidden='true'
				                                                                                  className='v-icon material-icons theme--light v-list-text'>arrow_back</i><span>WRÓĆ</span>
				</button>
				<h3 className='mt-5' id='list_name'>Lista sprawdzająca: {loadedListData?.code} - {loadedListData?.name}</h3>
				{blocksInList && blocksInList.length > 0 ? <DetailListTree questionList={loadedListData}/> : null}
				{this.state.openedPopup && error.isError ?  <PopUp
					type={'error'}
					title={'Błąd'}
					notification={'Nieautoryzowany dostęp. Żądanie zasobu, który wymaga uwierzytelnienia'}
					link={ null} // cannot be undefined because of PopUp.js implementation
					onClickEvent={null}
					closePopUp={() => this.handleClosePopUp()}
				/> : null}
				<div id='waiter'><Waiter loading={this.props.controlList.isLoading}/></div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch) => {
	return {
		listData: (listId) => dispatch(actionsLists.getSingleListData(listId))
	}
};

export const ControlListDetailProvider = connect(mapStateToProps, mapDispatchToProps)(ControlListDetail);




